import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

class BuildStatusService extends ServiceBase {
    /**
     * Fetches last known build status per job, admin only.
     * @returns {Promise} response with { count, items: [{rk, name, lastResult, lastNumber, lastSuccessNumber, lastSuccessEms, lastFailedNumber, lastFailedEms, ems}] }
     */
    getBuildStatuses = () => {
        const url = `${baseUrl}/${service}/build/statuses`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Starts build jobs via the build manager, admin only. 202 = request published, not = build started.
     * @param {string[]} names - job names, like KD8.JournalService.ACC
     * @returns {Promise}
     */
    postBuildJobs = (names) => {
        const url = `${baseUrl}/${service}/build/jobs`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}`, 'Content-Type': 'application/json' } };
        return agent.post(url, { data: names.map((name) => ({ name })) }, config);
    };
}

const buildStatusService = new BuildStatusService();
export default buildStatusService;
